export { ListaDestinos } from "./list";



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/destinos/index.tsx